import { ADDRESS_LIST, ADD_GUEST, GET_PROFILE, LOG_IN, LOG_OUT, SOCIAL_LOG_IN, SOCIAL_LOG_OUT,REMOVE_GUEST, APP_INSTALL, ORDER_TYPES } from "../actions/customerTypes";

const initialState: any = {
    customer: null,
    userInfo: {},
    addressData: [] || "",
    favItemData: [] || '',
    guestInfo: null,
    isLogged: false,
    socialLogin: false,
    cardDetails: [] || "",
    mobilecardDetails: [] || "",
    orderTypes: []
}
const customerReducer = (state = initialState, action: any) => {
    switch (action.type) {
        case "SAVE_USER_PROFILE":
            return {
                ...state,
                userInfo: action.payload,
            };
        case "SAVE_USER_CARD_DETAILS":
            return {
                ...state,
                cardDetails: action.payload,
            }
        case ORDER_TYPES: 
            return {
                ...state,
                orderTypes: action.payload
            }
        case "MOB_SAVE_USER_CARD_DETAILS":
            return  {
                ...state,
                mobilecardDetails: action.payload,
            }
        case "REMOVE_USER_PROFILE":
            return {
                ...state,
                userInfo: {}
            };
        case ADDRESS_LIST:
            return {
                ...state,
                addressData: action.payload,
            };
        case "FAV_MENU_ITEM": {
            return {
                ...state,
                favItemData: action.payload,
            };
        }
        case "REMOVE_FAV_MENU_ITEM":
            return {
                ...state,
                favItemData: []
            };
        case ADD_GUEST:
            return {
                ...state,
                guestInfo: action.payload
            };
        case REMOVE_GUEST:
            return {
                ...state,
                guestInfo: null
            };
        case GET_PROFILE:
            return {
                ...state,
                customer: action.payload,
                userInfo:action.payload
            };
        case LOG_IN:
            return {
                ...state,
                isLogged: true,
            };
        case LOG_OUT:
            return {
                ...state,
                isLogged: false,
            };
        case SOCIAL_LOG_IN:
            return {
                ...state,
                socialLogin: true,
            };
        case SOCIAL_LOG_OUT:
            return {
                ...state,
                socialLogin: false,
            };
        default: return state;
    }
}
export default customerReducer;